import { useState, useEffect } from 'react';

/**
 * 检测是否有弹窗遮挡
 * 通过检测 DOM 中是否存在弹窗相关的元素来判断
 * @returns {boolean} 是否有弹窗打开
 */
export function useModalOverlay() {
  const [hasModalOverlay, setHasModalOverlay] = useState(false);

  useEffect(() => {
    // 检测弹窗的函数
    const checkModalOverlay = () => {
      // 检测 Radix Dialog（含共享组件和直接使用 @radix-ui/react-dialog）
      // content 元素固定有 role="dialog" + data-state="open"
      const hasOpenDialog = !!document.querySelector('[role="dialog"][data-state="open"]');

      // 检测 Drawer
      const hasOpenDrawer = !!document.querySelector('[data-slot="drawer-overlay"][data-state="open"]');

      // 检测自定义 SideDrawer（无 data-state，通过可见性判断）
      const sideDrawer = document.getElementById('sideDrawerModalClick');
      const hasOpenSideDrawer = !!sideDrawer && window.getComputedStyle(sideDrawer).display !== 'none';

      setHasModalOverlay(hasOpenDialog || hasOpenDrawer || hasOpenSideDrawer);
    };

    // 初始检测
    checkModalOverlay();

    // 使用 MutationObserver 监听 DOM 变化
    const observer = new MutationObserver(checkModalOverlay);

    // 监听整个文档的变化
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state'],
    });

    // 也监听窗口大小变化（可能影响弹窗显示）
    window.addEventListener('resize', checkModalOverlay);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', checkModalOverlay);
    };
  }, []);

  return hasModalOverlay;
}

